import { Input, TableProps } from "antd";
import SearchIcon from "../../../../assets/icons/SearchIcon";
import CustomTable from "../../../../components/ui/CustomTable";
import useTable from "../../../../hooks/useTable";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { countParPageSerialNumber } from "../../../../utils/number";

export default function HistoryDetails() {
  const { page, limit, handlePagination, handleLimit } = useTable();
  const columns: TableProps<DataType>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: <div className="whitespace-nowrap !w-[120px]">Employee ID</div>,
      dataIndex: "employeeId",
    },
    {
      title: <span className="whitespace-nowrap">Employee Name</span>,
      align: "center",
      dataIndex: "employeeName",
    },
    {
      title: <span className="whitespace-nowrap">Month</span>,
      align: "center",
      dataIndex: "month", // fixed here
    },
    {
      title: <span className="whitespace-nowrap">Amount (BDT)</span>,
      dataIndex: "amount",
      align: "center",
      render: (val) => <div>৳ {val}</div>,
    },
    {
      title: <span className="whitespace-nowrap">Wallet Number</span>,
      dataIndex: "walletNumber",
    },
    {
      title: <span className="whitespace-nowrap">TRX ID</span>,
      dataIndex: "trxId", // fixed here
    },
    {
      title: <span className="whitespace-nowrap">Note</span>,
      dataIndex: "narration",
    },
    {
      title: <div className="whitespace-nowrap !w-[110px]">Status</div>,
      dataIndex: "status",
      align: "center",
      render: (value: DataType["status"]) => (
        <span
          className={`px-2 py-1 rounded text-xs font-medium ${
            value === "Complete"
              ? "bg-green-100 text-green-700"
              : "bg-yellow-100 text-yellow-700"
          }`}
        >
          {value}
        </span>
      ),
    },
  ];

  return (
    <>
      <SidebarLayout
        title="History Details"
        backLink="/admin/salary-disbursement/history"
      >
        <CustomTable
          loading={false}
          limit={limit}
          page={page}
          columns={columns}
          total={120} // Update total as per the data
          dataSource={data}
          handleLimit={handleLimit}
          handlePagination={handlePagination}
          filterSection={
            <>
              <Input
                suffix={<SearchIcon />}
                placeholder="Search"
                style={{ width: 220 }}
                allowClear
              />
            </>
          }
        />
      </SidebarLayout>
    </>
  );
}

interface DataType {
  id: number;
  employeeId: string;
  employeeName: string;
  month: string;
  amount: number;
  walletNumber: string;
  trxId: string;
  narration: string;
  status: "Complete" | "Partially Settled";
}

const data: DataType[] = [
  {
    id: 1,
    employeeId: "EMP001",
    employeeName: "John Doe",
    month: "May 2025",
    amount: 2500,
    walletNumber: "017XXXXXXXX",
    trxId: "TRX123456789",
    narration: "Salary for May",
    status: "Complete",
  },
  {
    id: 2,
    employeeId: "EMP002",
    employeeName: "Jane Smith",
    month: "May 2025",
    amount: 1500,
    walletNumber: "018XXXXXXXX",
    trxId: "TRX987654321",
    narration: "Partial salary",
    status: "Complete",
  },
];
